import { TooltipProps } from './Tooltip';
import classes from './Tooltip.module.css';

export const DefaultTooltipProps: Partial<TooltipProps> = {
  withArrow: true,
  arrowSize: 5,
  radius: 'sm'
};

export const TooltipOverrideClassNames = () => {
  return {
    tooltip: classes.tooltip
  };
};
